module.exports = __webpack_public_path__ + "img/produto-favorito.384bfad7.svg";